import axiosInstance from '../../lib/api/axios';
import { getServerUrl } from '../../lib/utils';
import { Entry } from '../entries/types';
import { CompleteMultipartUploadPayload, CreateMultipartUploadPayload, CreateMultipartUploadResponse, MediaUploadType } from './types';

export const createMultipartUpload = async (
  payload: CreateMultipartUploadPayload,
  mediaType: MediaUploadType,
): Promise<CreateMultipartUploadResponse> => {
  const { data } = await axiosInstance.post<CreateMultipartUploadResponse>(
    `${getServerUrl()}/assets/${mediaType}/createUpload`,
    payload,
  );
  return data;
};

export const completeMultipartUpload = async (
  payload: CompleteMultipartUploadPayload,
  mediaType: MediaUploadType,
): Promise<Entry> => {
  const { data } = await axiosInstance.post<Entry>(
    `${getServerUrl()}/assets/${mediaType}/completeUpload`,
    payload,
  );
  return data;
};
